export default function NotFound() {
  return (
    <div>
      <h1>
404 - Page not found
      </h1>
    </div>
  )
} 